import conn from "@/store/utils/connection";
import transaksiSnapcleanAPI from "@/store/utils/api-route/transaksiSnapcleanAPI";
import resulter from "@/store/utils/resulter";
import state from "./state"

const actions = {
	queryFilterTransaksiSnapclean({commit, rootGetters}, idkonsumen) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

		let query = {
			idkonsumenglobal: idkonsumen,
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
			limit: state.pagination.limit,
			offset: state.pagination.offset,
		}
		// periode
		if (getFilterItem.periode.filterBy !== "") {
			query.filter_by = getFilterItem.periode.filterBy

			switch (getFilterItem.periode.filterBy) {
				case "periode":
					query.tanggal_awal = getFilterItem.periode.startDate
					query.tanggal_akhir = getFilterItem.periode.endDate
					break;
				case "bulan":
					query.bulan = getFilterItem.periode.month
					break;
				case "tahun":
					query.tahun = getFilterItem.periode.year
					break;
				default:
					break;
			}
		}
		// jenis pembayaran
		if (getFilterItem.jenisPembayaranSnapclean.length > 0) {
			query.jenis_pembayaran_array = getFilterItem.jenisPembayaranSnapclean
		}
		// outlet
		if (getFilterItem.outlet.length > 0) {
			query.outlet_array = getFilterItem.outlet
		}
		// status bayar
		if (getFilterItem.statusPembayaran.length > 0) {
			query.status_bayar_array = getFilterItem.statusPembayaran
		}
		// jenis transaksi
		if (getFilterItem.jenisLayananSnapclean.length > 0) {
			query.jenis_transaksi_array = getFilterItem.jenisLayananSnapclean
		}
		// status transaksi
		if (getFilterItem.statusTransaksiSnapclean.length > 0) {
			query.status_transaksi_array = getFilterItem.statusTransaksiSnapclean
		}
		// mesin
		if (getFilterItem.mesinSnap !== "") {
			query.idmesin = getFilterItem.mesinSnap
		}
		// search
		if (state.isSearch) {
			query.key = state.search.key
		}

		return query
	},

	async fetchListTransaksiKonsumen({commit, dispatch}, id) {
		try {
			let query = await dispatch("queryFilterTransaksiSnapclean", id)
			const res = await conn.get(transaksiSnapcleanAPI.customer.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				let objQuery = conn.setQueryString(query)
				commit("setQueryListTransaksi", objQuery)
				commit("setListTransaksiKonsumen", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListHistoryPaylinkKonsumen({commit}, payload) {
		try {
			let query = {
				idkonsumen_global: payload.idcustomer,
				tipe: payload.tipe,
				limit: state.pagination.limit,
				offset: state.pagination.offset,
			}
			const res = await conn.get(transaksiSnapcleanAPI.customer.paylink, query)
			if (!res.data) {
				console.log("err", res)
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setListHistoryPaylinkKonsumen", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			console.log("e", e)
			return resulter.errorResult(e)
		}
	},
	async fetchInfoTransaksiKonsumen({commit, dispatch}, id) {
		try {
			let query = await dispatch("queryFilterTransaksiSnapclean", id)
			const res = await conn.get(transaksiSnapcleanAPI.customer.info, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setInfoTransaksiKonsumen", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchDetailTransaksi({commit}, id) {
		try {
			let query = {idtransaksi: id}
			const res = await conn.get(transaksiSnapcleanAPI.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailTransaksi", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async deleteTransaksi({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idtransaksi", payload.id)
			if (payload.keterangan !== "") form.append("keterangan", payload.keterangan)
			if (payload.idakunRefund !== "") form.append("idakun_refund", payload.idakunRefund)
			const res = await conn.post(transaksiSnapcleanAPI.delete, form, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async export({commit, dispatch}, payload) {
		try {
			let query = await dispatch("queryFilterTransaksiSnapclean", payload.id)
			let formData = new FormData
			formData.append("type", payload.type)
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(transaksiSnapcleanAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				let keyExport = "export:job:transaksi:snap"
				localStorage.setItem("key_export_transaksi_snapclean", keyExport)
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportTrack({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_transaksi_snapclean")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport
			}
			const res = await conn.get(transaksiSnapcleanAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(transaksiSnapcleanAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		// localStorage.removeItem("key_export_transaksi_snapclean")
		try {
			let keyExport = localStorage.getItem("key_export_transaksi_snapclean")
			let query = {
				key: keyExport
			}
			const res = await conn.get(transaksiSnapcleanAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_transaksi_snapclean")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
}

export default actions